import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import InlineVideo from '../video/inline'

import styles from './styles'

const VideoSlice = withStyles(styles)(props => {
  const { classes, video } = props
  let obj = { src: video.video.url_dash.url }
  let data = []
  data.push(obj)
  data.push(obj)
  let poster = video.video.poster
  poster.src = video.video.poster.url
  return (
    <div className={classes.contents}>
      <div className={classes.section}>
        <div className={classes.videospacing}>
          {video.title && (
            <Typography gutterBottom variant="title">
              {video.title.text}
            </Typography>
          )}
          {video.subtitle && (
            <Typography gutterBottom variant="subheading">
              {video.subtitle.text}
            </Typography>
          )}
          <Grid container spacing={40}>
            <Grid item xs={12}>
              <InlineVideo urls={data} poster={poster} />
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  )
})

export default withStyles(styles)(VideoSlice)



// WEBPACK FOOTER //
// ./src/components/video/slice.js